// material-ui
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

// project imports
import { useTranslation } from 'hooks/useTranslation';

// ==============================|| SELECTOR DE IDIOMA ||============================== //
// Cambia el idioma de toda la interfaz. Las opciones salen del registro de
// idiomas (i18n/index.js), así que agregar uno nuevo no toca este componente.

export default function LanguageSelector({ size = 'small' }) {
  const { locale, setLocale, idiomas, t } = useTranslation();

  return (
    <Select
      size={size}
      value={locale}
      onChange={(event) => setLocale(event.target.value)}
      inputProps={{ 'aria-label': t('language.change') }}
      sx={{ minWidth: 120 }}
    >
      {idiomas.map((idioma) => (
        <MenuItem key={idioma.code} value={idioma.code}>
          {idioma.label}
        </MenuItem>
      ))}
    </Select>
  );
}
